<template>
  <v-app id="login">
    <v-content>
      <v-container fluid fill-height>
        <v-layout justify-center align-center>
          <v-flex xs12 sm12 md8>
            <v-layout wrap>
              <v-flex xs12 sm12 md6>
                <v-container fluid class="text-center">
                  <img src="@/assets/logo.png" height="250" width="auto"/>
                  <!--<div class="display-1 font-weight-bold mt-2 primary--text"></div>-->
                </v-container>
              </v-flex>
              <v-flex xs12 sm12 md6>
                <v-form @submit.prevent="submit">
                  <v-card color="primary" elevation="5" dark>
                    <v-card-title class="headline pl-5">Iniciar sesión</v-card-title>
                    <v-card-text>
                      <v-text-field v-model="username" :disabled="loading" prepend-icon="mdi-account" required
                      label="Usuario" @input="$v.username.$touch()" @blur="$v.username.$touch()">
                      </v-text-field>
                      <v-text-field v-model="password" type="password" :disabled="loading" prepend-icon="mdi-lock" required
                      label="Contraseña" @input="$v.password.$touch()" @blur="$v.password.$touch()">
                      </v-text-field>
                      <v-btn text small :disabled="loading" style="text-transform: none !important;" @click="forgot()">¿Has olvidado tu contraseña?</v-btn>
                    </v-card-text>
                    <v-card-actions>
                      <div class="pl-3">v{{ version }}</div>
                      <v-spacer></v-spacer>
                      <v-btn type="submit" text :loading="loading">Entrar</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-form>
                <v-snackbar v-model="error" color="error" :timeout="2500" bottom right>
                  {{ message }}
                </v-snackbar>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <v-footer padless>
      <v-card class="flex" flat tile color="#ffffff">
        <v-card-text class="py-2 text-center">
           <v-btn text small  style="text-transform: none !important;" @click="viewNoticyPrivacy()">Aviso de privacidad</v-btn><v-icon class="mr-2">mdi-circle-medium</v-icon>{{ new Date().getFullYear() }} — <strong>Censo MKD</strong>
        </v-card-text>
      </v-card>
    </v-footer>
  </v-app>
</template>

<script>
import { mapActions } from 'vuex'
import { validationMixin } from 'vuelidate'
import { required, maxLength } from 'vuelidate/lib/validators'
import services from '@/utils/services'

export default {
  name: 'login',
  mixins: [validationMixin],
  validations: {
    username: {
      required,
      maxLength: maxLength(50)
    },
    password: {
      required,
      maxLength: maxLength(50)
    }
  },
  data: () => ({
    version: process.env.VUE_APP_VERSION,
    loading: false,
    error: false,
    message: '',
    username: '',
    password: ''
  }),
  computed: {
    usernameErrors() {
      const errors = []
      if (!this.$v.username.$dirty) return errors
      !this.$v.username.required && errors.push('El campo es obligatorio')
      !this.$v.username.maxLength && errors.push('El campo excede la longitud máxima')
      return errors
    },
    passwordErrors() {
      const errors = []
      if (!this.$v.password.$dirty) return errors
      !this.$v.password.required && errors.push('El campo es obligatorio')
      !this.$v.password.maxLength && errors.push('El campo excede la longitud máxima')
      return errors
    }
  },
  methods: {
    ...mapActions('general', [
      'newUser',
    ]),
    clear() {
      this.$v.$reset()
      this.username = ''
      this.password = ''
    },
    forgot() {
      this.$router.push('/forgot')
    },
    submit() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.login()
      }
      else {
        this.error = true
        this.message = 'Algunos datos del formulario son incorrectos'
      }
    },
    login() {
      this.loading = true
      setTimeout(() => {
        this.axios.post(services.routes.login, { username: this.username, password: this.password })
          .then(response => {
            let res = response.data
            if (res.correcto) {
              this.$session.start()
              this.$session.set('jwt', res.data.token)
              this.newUser({ usr_nm: res.data.usr_nm, perfil: res.data.detalle.perfil })
              this.$router.push('/home')
            } else {
              this.error = true
              this.message = res.mensaje
            }
          })
          .catch(error => {
            console.log(error)
            this.error = true
            this.message = 'El servicio no se encuentra disponible en estos momentos'
          })
          .finally(() => {
            this.loading = false
          })
      }, 300)
    },
    viewNoticyPrivacy() {
      let routeData = this.$router.resolve({ name: 'NoticePrivacy' });
      window.open(routeData.href, '_blank');
    }
  }
}
</script>

